import pic from "./assets/img.jpg";
import "./style/App.css";
import Education from "./components/Education";
import Work from "./components/Work";
// import Certifications from "./components/Certifications";
// import Theses from "./components/Theses";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="header-container">
      <header class="header"></header>

      <div className="bio">
        <div class="profile-container">
          <img src={pic} alt="Profile" className="profile-image" />

          <div className="title">Yaman Sanobar</div>
        </div>
        <div className="intro">
          {" "}
          I'm a full-stack developer and educator focused on building intuitive,
          easy-to-use, and user-centered digital tools. I currently teach
          full-stack development, helping aspiring developers gather the
          confidence and skills to build real-world applications. I have worked
          over teaching, research, and industry; This experience gives me
          insight into how things are built and how people actually use them.
          With a background in computer science, I approach each project with
          curiosity and a focus on creating meaningful connections between
          people and technology. Whether I’m coding or mentoring, I aim to pass
          on work that’s well-crafted, engaging, and supports others in learning
          and growing.
        </div>

        <div className="spacing"></div>
        <div className="spacing"></div>
        <Work />
        <Education />

        {/* <Certifications /> */}
        <br />
        <br />
        <br />
        <br />
      </div>
      <Footer />
    </div>
  );
}

export default App;
